<!--
  name : 김혜진
  desc : 계약승인-비회원
  date : 2020-09-21
-->
<template>
  <div>
    <!--2step 다음 버튼-->
    <v-dialog v-model="dialogContrOk" max-width="800px" persistent>
      <v-card id="popStyle03">
        <!--팝업 제목-->
        <v-card-title class="title">
          {{ contractDetailInfo.contractStatus | ctrStatToStr }}
          <v-btn fab class="popBtnClose" @click="close"></v-btn>
        </v-card-title>
        <!--/팝업 제목-->
        <!--팝업 내용-->
        <v-card-text>
          <v-row no-gutters class="justify-center popCon">
            <div class="dot_tt16 mb-2">계약 진행 상태</div>
            <v-col cols="12" class="next2step_end_logBox row_mb-40">
              <v-card-text class="box_log">
                <ul>
                  <li>
                    <div
                      class="popContrOk_Box"
                      v-if="contractDetailInfo !== null"
                    >
                      <div v-if="contractDetailInfo.senderBrokerName !== null">
                        <li>
                          <div
                            class="box_log_icon"
                            v-if="contractDetailInfo.contractStatus === 'CN'"
                          >
                            <!--class=
                                  (고정)log_icon
                                  (상태에 따라)
                                  저장 = type01_01 / 거부 = type01_02 / 완료  = type01_03
                                  전송 = type02_00 / 검토요청 = type02_01
                                  서명(내서명) = type03_01 / 서명(남서명) = type03_02 /
                                -->
                            <span class="log_icon type01_02"></span>
                            <!--계약로그 상태-->
                            <span class="txt_ing">승인거부</span>
                            <!--계약로그 년월일-->
                            <span class="txt_date">{{
                              contractDetailInfo.sentDatetime
                            }}</span>
                          </div>
                          <div
                            class="box_log_icon"
                            v-else-if="
                              contractDetailInfo.contractStatus === 'CC'
                            "
                          >
                            <span class="log_icon type01_03"></span>
                            <!--계약로그 상태-->
                            <span class="txt_ing">완료</span>
                            <span class="txt_date">{{
                              contractDetailInfo.sentDatetime
                            }}</span>
                          </div>
                          <div
                            class="box_log_icon"
                            v-else-if="
                              contractDetailInfo.contractStatus === 'CR' &&
                                getAddress(contractDetailInfo.receiverAddress)
                            "
                          >
                            <span class="log_icon type03_01"></span>
                            <!--계약로그 상태-->
                            <span class="txt_ing">서명(내서명)</span>
                            <span class="txt_date">{{
                              contractDetailInfo.sentDatetime
                            }}</span>
                          </div>
                          <div
                            class="box_log_icon"
                            v-else-if="
                              contractDetailInfo.contractStatus === 'CR' &&
                                getAddress(contractDetailInfo.senderAddress)
                            "
                          >
                            <span class="log_icon type03_02"></span>
                            <!--계약로그 상태-->
                            <span class="txt_ing">서명(남서명)</span>
                            <span class="txt_date">{{
                              contractDetailInfo.sentDatetime
                            }}</span>
                          </div>
                          <div class="box_log_txt">
                            [송신자] {{ contractDetailInfo.senderName }} 가
                            요청한 [{{ contractDetailInfo.contractFileName }}]
                            를 {{ authDialog.title }} 합니다.
                          </div>
                        </li>
                      </div>
                      <div v-else>
                        <li>
                          <div class="box_log_icon">
                            <div
                              v-if="contractDetailInfo.contractStatus === 'CN'"
                            >
                              <span class="log_icon type01_02"></span>
                              <!--계약로그 상태-->
                              <span class="txt_ing">승인거부</span>
                            </div>
                            <div
                              v-else-if="
                                contractDetailInfo.contractStatus === 'CC'
                              "
                            >
                              <span class="log_icon type01_03"></span>
                              <!--계약로그 상태-->
                              <span class="txt_ing">완료</span>
                            </div>
                            <div
                              v-else-if="
                                contractDetailInfo.contractStatus === 'CR' &&
                                  getAddress(contractDetailInfo.receiverAddress)
                              "
                            >
                              <span class="log_icon type03_01"></span>
                              <!--계약로그 상태-->
                              <span class="txt_ing">서명(내서명)</span>
                            </div>
                            <div
                              v-else-if="
                                contractDetailInfo.contractStatus === 'CR' &&
                                  getAddress(contractDetailInfo.senderAddress)
                              "
                            >
                              <span class="log_icon type03_02"></span>
                              <!--계약로그 상태-->
                              <span class="txt_ing">서명(남서명)</span>
                            </div>
                            <!--계약로그 년월일-->
                            <span class="txt_date">{{
                              contractDetailInfo.sentDatetime
                            }}</span>
                          </div>
                          <div class="box_log_txt">
                            [송신자]
                            {{ contractDetailInfo.senderName }} [대행자]
                            {{ contractDetailInfo.senderBrokerName }} 가 요청한
                            [{{ contractDetailInfo.contractFileName }}] 를
                            {{ authDialog.title }} 합니다.
                          </div>
                        </li>
                      </div>
                    </div>
                  </li>
                </ul>
              </v-card-text>
            </v-col>
            <v-col
              :cols="
                contractDetailInfo.contractNumber.indexOf('NYM') >= 0
                  ? '12'
                  : '9'
              "
              class="popaddMark_btnCon"
            >
              <div
                class="dot_tt16 mb-2"
                v-if="
                  contractDetailInfo.contractStatus === 'CR' &&
                    contractDetailInfo.contractNumber.indexOf('NYM') >= 0
                "
              >
                <span v-if="!attachFile">
                  ※ 공정거래협약 체결용<br /><br />
                  3차협력사와 체결 대상 협력사께서는 당사 전자협약체결 전
                  <br /><br />
                  대표 샘플 1부 스캔본 첨부 후 체결 바랍니다.(협약 체결 후 첨부
                  불가)
                  <v-btn
                    outlined
                    class="btn17_00 btn_pAright"
                    @click="clickUploadFile"
                    >첨부파일</v-btn
                  >
                </span>
                <span v-else
                  >{{ attachFile !== null ? attachFile.name : "" }}
                  <v-btn
                    fab
                    dark
                    x-small
                    color="red"
                    icon
                    @click="removeAttachFile(attachFile)"
                  >
                    <v-icon dark>
                      mdi-window-close
                    </v-icon>
                  </v-btn>
                </span>
                <input
                  ref="fileInput"
                  type="file"
                  style="display:none"
                  @change="changeUploadFile"
                />
              </div>
            </v-col>
            <v-col
              cols="3"
              class="popaddMark_btnCon"
              v-if="
                contractDetailInfo.contractStatus !== 'DR' &&
                  contractDetailInfo.contractNumber.indexOf('NYM') === -1
              "
            >
              <div class="dot_tt16 mb-2">
                <!--워터마크 : {{wmAttach?'첨부':'미첨부'}} --><!--첨부상태 표시: 첨부/미첨부-->
                <v-btn
                  outlined
                  class="btn17_00 btn_pAright"
                  @click="openWmDialog()"
                  >서명/워터마크 첨부</v-btn
                >
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <!--/팝업 내용-->
        <!--팝업 버튼-->
        <v-card-actions class="justify-center">
          <!--회원탈퇴 tab 누를시만 버튼 네임 변경-->
          <v-btn
            text
            @click="
              chainAuthVisible(
                anyRequestToApproveChangeStatus(
                  contractDetailInfo.contractStatus
                )
              )
            "
            >확인</v-btn
          >
          <v-btn text @click="close">취소</v-btn>
        </v-card-actions>
        <!--/팝업 버튼-->
      </v-card>
    </v-dialog>
    <!--/2step 다음 버튼-->
    <s-confirm ref="confirm"></s-confirm>
    <s-loading ref="loading"></s-loading>
    <insert-watermark
      ref="insertWatermark"
      :groupId="-1"
      :contractNum="convertedInfo.contractNumber"
      :pdfFileName="convertedInfo.convertedCtrFileName"
      :contractDetailInfo="contractDetailInfo"
      contractStatus="CC"
      :signal="signal"
      :key="componentKey"
      @child="fnWmAttach"
    ></insert-watermark>
    <pubCert
      ref="pubCert"
      :cert-regno="purCertInfo.certRegNo"
      :hash="purCertInfo.hash"
      @childs-event="purCertResult"
    ></pubCert>
    <chainPass
      ref="chainPass"
      :chain-address="this.contractDetailInfo.chainAddress"
      @chainPassEvent="chainPassResult"
    ></chainPass>
  </div>
</template>
<script>
import insertWatermark from "@/views/contractLock/components/insertWatermark";
import PubCert from "@/components/pubCert";
import ChainPass from "@/components/chainPass";
import {
  changeStatusForApprove,
  getFileHash,
  verifyChain,
  approvalReviewNomem,
  approvalDestroyContractNomem,
  uploadFile
} from "@/api/contractLock";
import { approvalContractNomem } from "@/api/contractLock";

export default {
  name: "popContrOk",
  components: {
    insertWatermark,
    PubCert,
    ChainPass
  },
  props: {
    authDialog: [Object, String],
    contractDetailInfo: [Object, String],
    convertedInfo: [Object, String],
    senderBrokerName: String,
    senderName: String,
    contractFileName: String,
    title: String,
    convertedCtrFileName: String,
    contractNumber: String,
    isWmAttach: Boolean,
    signal: String,
    purCertInfo: [Object, String]
  },
  filters: {
    ctrStatToStr(value) {
      let str = "";
      if (value) {
        switch (value) {
          case "PR":
            str = "검토요청";
            break;
          case "PN":
            str = "검토거부";
            break;
          case "PA":
            str = "검토취소";
            break;
          case "PC":
            str = "검토승인";
            break;
          case "CR":
            str = "계약요청";
            break;
          case "CN":
            str = "계약거부";
            break;
          case "CA":
            str = "계약취소";
            break;
          case "CC":
            str = "계약승인";
            break;
          case "DR":
            str = "폐기요청";
            break;
          case "DN":
            str = "폐기거부";
            break;
          case "DA":
            str = "폐기취소";
            break;
          case "DC":
            str = "폐기승인";
            break;
          default:
            str = value;
        }
      }
      return str;
    }
  },
  data() {
    return {
      insertWatermark: false,
      //  다이얼로그
      dialogContrOk: false,
      // 컴포넌트 강제 리렌더링을 위한 변수 (component의 key 값을 변경함으로써 기존 component가 자신을 다시 초기화하고 재설정한다.)
      componentKey: 0,
      wmAttach: false,
      hashFileName: "",
      hashValue: "",
      certPEM: "",
      // 첨부파일
      attachFile: null,
      // 첨부파일 허용 확장자
      accessFileExtensions: [
        "doc",
        "docx",
        "xls",
        "xlsx",
        "ppt",
        "pptx",
        "pdf"
      ],
      attachFileInfo: null,
    };
  },
  created() {},
  mounted() {},
  methods: {
    open() {
      this.dialogContrOk = true;
      this.wmAttach = this.isWmAttach;
    },
    openWmDialog() {
      this.$refs.insertWatermark.open();
    },
    fnWmAttach: function(message) {
      this.wmAttach = message;
    },
    getAddress(address) {
      var orgname = this.$store.state.user.orgname;
      var orgaddr = this.$store.state.user.orgaddr;
      var useraddr = this.$store.state.user.useraddr;
      if (orgname) {
        if (orgaddr === address) {
          return true;
        } else {
          return false;
        }
      } else {
        if (useraddr === address) {
          return true;
        } else {
          return false;
        }
      }
    },
    // 승인 데이터 (계약요청승인, 검토요청승인 등등 - 이 후 만료, 파기등 기능이 추가될 수도..)
    anyRequestToApproveChangeStatus(status) {
      var result = null;
      if (status === "CR") {
        // 계약 요청 시 승인 상태 코드
        result = "CC";
      } else if (status === "PR") {
        // 검토 요청 시 승인 상태 코드
        result = "PC";
      } else if (status === "DR") {
        // 폐기 요청 시 승인 상태 코드
        result = "DC";
      }
      return result;
    },
    // 블록체인 인증 (승인 / 거부 / 취소 클릭 시)
    chainAuthVisible(changeStatus) {
      this.authDialog.changeStatus = changeStatus;

      // 블록체인 인증 창 상태값에 따른 텍스트 변경 및 블록체인 인증 창 활성화
      if (changeStatus === "CC") {
        this.authDialog.title = "계약승인";
        this.authDialog.authUserText = "계약 수신자";
        this.authDialog.warningText =
          "블록체인 인증이 완료되어야 계약승인이 완료됩니다.";
        this.authDialog.changeStatusText = "계약 승인 중입니다.";
        this.authDialog.endMessage =
          '<strong style="font-size: 15px;">계약승인</strong>이 완료 되었습니다.';
        // 승인 시 블록체인 인증 창을 활성화 하기 전 기업일 경우 잔여 포인트 확인
        this.$refs.confirm
          .open("confirm", "계약승인", "계약승인 하시겠습니까?")
          .then(() => {
            this.confirmAuth();
          });
      } else if (changeStatus === "PC") {
        this.authDialog.title = "검토승인";
        this.authDialog.authUserText = "검토 수신자";
        this.authDialog.warningText =
          "블록체인 인증이 완료되어야 검토승인이 완료됩니다.";
        this.authDialog.changeStatusText = "검토승인 중입니다.";
        this.authDialog.endMessage =
          '<strong style="font-size: 15px;">검토승인</strong>이 완료 되었습니다.';
        // 승인 시 블록체인 인증 창을 활성화 하기 전 기업일 경우 잔여 포인트 확인
        this.$refs.confirm
          .open("confirm", "검토승인", "검토승인 하시겠습니까?")
          .then(() => {
            this.confirmAuth();
          });
      } else if (changeStatus === "DC") {
        this.authDialog.title = "계약폐기";
        this.authDialog.authUserText = "폐기승인 수신자";
        this.authDialog.warningText =
          "블록체인 인증이 완료되어야 계약폐기가 완료됩니다.";
        this.authDialog.changeStatusText = "계약폐기 중입니다.";
        this.authDialog.endMessage =
          '<strong style="font-size: 15px;">계약폐기</strong>가 완료 되었습니다.';
        // 승인 시 블록체인 인증 창을 활성화 하기 전 기업일 경우 잔여 포인트 확인
        this.$refs.confirm
          .open("confirm", "계약폐기", "계약을 폐기하시겠습니까?")
          .then(() => {
            this.confirmAuth();
          });
      }
    },
    confirmAuth() {
      if (this.contractDetailInfo.signType === 1) {
        if (this.wmAttach) {
          this.hashFileName = this.$store.state.app.convertPdfName;
        } else {
          this.hashFileName = this.convertedInfo.convertedCtrFileName;
        }

        getFileHash({ contractFileName: this.hashFileName })
          .then(response => {
            if (response.rdata.rcode === 20000) {
              this.purCertInfo.hash = response.rdata.hashValue;
              this.$refs.pubCert.open();
            }
          })
          .catch(e => {
            console.log(e);
          });
      } else {
        this.submitAuthChain();
      }
    },
    // [2차 블록체인 인증] 마지막 블록체인 인증 창에서 확인 눌렀을 때
    submitAuthChain() {
      var changeStatusParam = this.paramsForChangeStatus();
      this.$refs.loading.start("블록체인 인증 중입니다.");
      verifyChain(changeStatusParam)
        .then(response => {
          this.$refs.loading.end();
          if (response.rdata.rcode === 20000) {
            if (changeStatusParam.ctrStat === "CC") {
              if (this.isV4(changeStatusParam.ctrNo)) {
                this.approvalContractNomem(changeStatusParam);
              } else {
                this.changeStatusApprove(changeStatusParam);
              }
            } else if (changeStatusParam.ctrStat === "PC") {
              this.approvalReviewNomem(changeStatusParam);
            } else if (changeStatusParam.ctrStat === "DC") {
              this.approvalDestroyContractNomem(changeStatusParam);
            }
          } else if (response.rdata.rcode === 30011) {
            this.$refs.confirm.open(
              "alert",
              "",
              "블록체인 인증에 실패했습니다. ( 실패이유 - " +
                response.rdata.rmessage +
                " )"
            );
          } else {
            this.$refs.confirm.open(
              "alert",
              "",
              "블록체인 인증에 실패했습니다. 다시 시도하거나 관리자에게 문의해주세요."
            );
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    // 상태변경을 위한 데이터를 만들어주는 함수 (중복이 되어서 따로 만듦)
    paramsForChangeStatus() {
      var changeStatusParam = {};
      changeStatusParam.chainAddr = this.contractDetailInfo.chainAddress;
      changeStatusParam.chainPass = this.contractDetailInfo.chainPassword;
      changeStatusParam.ctrNo = this.contractDetailInfo.contractNumber;
      changeStatusParam.ctrSeq = this.contractDetailInfo.contSeq;
      changeStatusParam.ctrStat = this.authDialog.changeStatus;
      changeStatusParam.signType = this.contractDetailInfo.signType;
      changeStatusParam.hash = this.hashValue;
      changeStatusParam.certPEM = this.certPEM;
      changeStatusParam.attachFileInfo = this.attachFileInfo;
      if (
        this.authDialog.changeStatus === "CC" ||
        this.authDialog.changeStatus === "PC"
      ) {
        if (this.wmAttach) {
          changeStatusParam.pdfFileName = this.$store.state.app.convertPdfName;
        } else {
          changeStatusParam.pdfFileName = this.convertedInfo.convertedCtrFileName;
        }
      }

      // 고려아연 비회원
      if (this.contractDetailInfo.contractNumber.indexOf("KRZ-")) {
        console.log("폐기사유 : ", this.contractDetailInfo.rejectMessage);
        changeStatusParam.rejectMsg = this.contractDetailInfo.rejectMessage;
      }

      return changeStatusParam;
    },
    // [상태변경] 승인
    changeStatusApprove(changeStatusParam) {
      this.$refs.loading.start(this.authDialog.changeStatusText);
      changeStatusForApprove(changeStatusParam)
        .then(response => {
          this.$refs.loading.end();
          if (response.rdata.rcode === 20000) {
            this.$refs.confirm.open(
              "alert",
              this.authDialog.title,
              this.authDialog.endMessage
            );
            this.close();
            this.$emit("childs-event", "");
          } else if (response.rdata.rcode === 30011) {
            this.$refs.confirm.open(
              "alert",
              this.authDialog.title,
              this.authDialog.title +
                "에 실패했습니다. ( 실패이유 - " +
                response.rdata.rmessage +
                " )"
            );
          } else {
            this.$refs.confirm.open(
              "alert",
              this.authDialog.title,
              "현재 계약서 처리량이 많아 승인이 지연되고 있습니다. 잠시 후에 다시 시도해 주세요. 이 메시지가 3번 이상 반복될 경우 고객센터(1588-8064)로 문의해 주세요."
            );
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    // [v4] 계약승인
    approvalContractNomem(changeStatusParam) {
      this.$refs.loading.start(this.authDialog.changeStatusText);
      approvalContractNomem(changeStatusParam)
        .then(response => {
          this.$refs.loading.end();
          if (response.rdata.rcode === 20000) {
            this.$refs.confirm.open(
              "alert",
              this.authDialog.title,
              this.authDialog.endMessage
            );
            this.close();
            this.$emit("childs-event", "");
          } else if (response.rdata.rcode === 30011) {
            this.$refs.confirm.open(
              "alert",
              this.authDialog.title,
              this.authDialog.title +
                "에 실패했습니다. ( 실패이유 - " +
                response.rdata.rmessage +
                " )"
            );
          } else {
            this.$refs.confirm.open(
              "alert",
              this.authDialog.title,
              this.authDialog.title +
                "에 실패했습니다. 다시 시도하거나 관리자에게 문의해주세요."
            );
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    // [상태변경] 검토승인
    approvalReviewNomem(changeStatusParam) {
      this.$refs.loading.start(this.authDialog.changeStatusText);
      approvalReviewNomem(changeStatusParam)
        .then(response => {
          this.$refs.loading.end();
          if (response.rdata.rcode === 20000) {
            this.$refs.confirm.open(
              "alert",
              this.authDialog.title,
              this.authDialog.endMessage
            );
            this.close();
            this.$emit("childs-event", "");
          } else if (response.rdata.rcode === 30011) {
            this.$refs.confirm.open(
              "alert",
              this.authDialog.title,
              this.authDialog.title +
                "에 실패했습니다. ( 실패이유 - " +
                response.rdata.rmessage +
                " )"
            );
          } else {
            this.$refs.confirm.open(
              "alert",
              this.authDialog.title,
              this.authDialog.title +
                "에 실패했습니다. 다시 시도하거나 관리자에게 문의해주세요."
            );
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    // [상태변경] 폐기승인
    approvalDestroyContractNomem(changeStatusParam) {
      this.$refs.loading.start(this.authDialog.changeStatusText);
      approvalDestroyContractNomem(changeStatusParam)
        .then(response => {
          this.$refs.loading.end();
          if (response.rdata.rcode === 20000) {
            this.$refs.confirm.open(
              "alert",
              this.authDialog.title,
              this.authDialog.endMessage
            );
            this.close();
            this.$emit("childs-event", "");
          } else if (response.rdata.rcode === 30011) {
            this.$refs.confirm.open(
              "alert",
              this.authDialog.title,
              this.authDialog.title +
                "에 실패했습니다. ( 실패이유 - " +
                response.rdata.rmessage +
                " )"
            );
          } else {
            this.$refs.confirm.open(
              "alert",
              this.authDialog.title,
              this.authDialog.title +
                "에 실패했습니다. 다시 시도하거나 관리자에게 문의해주세요."
            );
          }
        })
        .catch(e => {
          this.$refs.loading.end();
          console.log(e);
          this.$refs.confirm.open(
            "alert",
            this.authDialog.title,
            this.authDialog.title +
              "에 실패했습니다. 다시 시도하거나 관리자에게 문의해주세요."
          );
        });
    },
    purCertResult: function(vid, errorMessage, sign, certPEM) {
      this.errorMessage = errorMessage;
      if (vid) {
        this.hashValue = sign;
        this.certPEM = certPEM;
        this.submitAuthChain();
      } else {
        this.$refs.confirm.open(
          "alert",
          "공동인증",
          "공동인증에 실패하였습니다." + this.errorMessage
        );
      }
    },
    chainPassResult: function(pass) {
      this.contractDetailInfo.chainPassword = pass;
      this.submitAuthChain();
    },
    /* 파일첨부버튼 클릭 */
    clickUploadFile() {
      this.$refs.fileInput.value = "";
      this.$refs.fileInput.click();
    },
    changeUploadFile(e) {
      this.addAttachFile(e.target.files[0]);
    },
    addAttachFile(file) {
      this.$refs.confirm
        .open(
          "confirm",
          "파일 첨부",
          "<strong>" + file.name + "</strong>을 첨부하시겠습니까?"
        )
        .then(() => {
          if (this.verifyUploadFile(file)) {
            this.attachFile = file;
            let formData = new FormData();
            formData.append("file", file);
            this.$refs.loading.start(
              "첨부 파일을 업로드 중 입니다. 잠시만 기다려주세요."
            );
            uploadFile(formData)
              .then(response => {
                this.$refs.loading.end();
                if (response.rcode === 20000) {
                  this.attachFileInfo = {
                    convId: response.rdata.convId,
                    oriFileName: response.rdata.oriFileName
                  };
                } else {
                  this.$refs.confirm.open(
                    "alert",
                    "파일 첨부",
                    "첨부 파일 업로드를 실패했습니다."
                  );
                }
              })
              .catch(e => {
                console.error(e);
                this.$refs.loading.end();
                this.$refs.confirm.open(
                  "alert",
                  "파일 첨부",
                  "첨부 파일 업로드를 실패했습니다."
                );
              });
          }
        });
    },
    close() {
      this.dialogContrOk = false;
      this.attachFile = null;
      this.attachFileInfo = null;
    },
    removeAttachFile(file) {
      this.$refs.confirm
        .open("confirm", "파일 첨부", file.name + "을 삭제하시겠습니까?")
        .then(() => {
          this.attachFile = null;
          this.attachFileInfo = null;
        });
    },
    /* 파일 유효성 검사 */
    verifyUploadFile(file) {
      var fileNameSize = file.name.length;
      var lastDotIndex = file.name.lastIndexOf(".");
      var fileExt = file.name
        .substring(lastDotIndex + 1, fileNameSize)
        .toLowerCase();
      var verify = true;
      // 허용된 파일 확장자인지 검사
      if (this.accessFileExtensions.indexOf(fileExt) === -1) {
        verify = false;
        this.$refs.confirm.open(
          "alert",
          "첨부파일 업로드",
          "업로드 파일의 확장자를 확인해주세요. (허용된 확장자 : " +
            this.accessFileExtensions.map(s => " ." + s).toString() +
            ")"
        );
      }
      return verify;
    },
    // V4 사용하는 계약번호
    isV4(ctrNo) {
      let result = false;
      if (ctrNo.length === 22) {
        result = true;
      } else if (ctrNo.indexOf("KRH-") >= 0 || ctrNo.indexOf("PMO-") >= 0) {
        result = true;
      }
      return result;
    }
  }
};
</script>
<style scoped></style>
